// eslint-disable-next-line import/prefer-default-export
export const ERROR_CODES = {
  unauthorized: 401,
  notFound: 404,
};

export const VALID_ERROR_MESSAGES = ['Error: Video event has been completed'];
